import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { getScrollBarAppState } from "orion-components/AppState/Global/selectors";

function modifyDefaultScrollValue(newValue) {
	document.documentElement.style.setProperty("--displayScrollbar", newValue);
}

const ScrollbarService = () => {
	const scrollBarsEnabled = useSelector((state) => getScrollBarAppState(state));
	useEffect(() => {
		if (scrollBarsEnabled) {
			modifyDefaultScrollValue("block");
		} else {
			modifyDefaultScrollValue("none");
		}
	}, [scrollBarsEnabled]);
	return <Fragment />;
};

export default ScrollbarService;
